function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.4.3c-21.3 0-39.5 7.5-53.4 14.9C176.1 7.7 159 .3 136.6.3 92.8.3 65 28.1 65 77.3c0 58.7 56.6 116.4 125 163.4 68.4-45.9 125-103.5 125-163.4 0-49.2-28.9-77-71.6-77z",
  fill: "#CCC"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.5 78.2C71.5 138 135.6 194.6 189 232c16.1-10.7 32-23.5 47-36.3C164.4 135.9 96.1 81.4 72.6 62.3c-.1 4.1-1.1 9.5-1.1 15.9z",
  fill: "url(#swa_svg__paint0_linear_0_4)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M303.2 106c-52.3-42.8-83.4-65.2-117.5-85.4-9.6-5.4-27.8-13.9-48-13.9-19.3 0-36.3 6.4-48 18.1-7.5 7.5-12.9 17-14.9 28.9 26.6 19.3 100.3 71.6 174 130.3 24.5-23.6 44.8-50.3 54.4-78z",
  fill: "url(#swa_svg__paint1_linear_0_4)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289.3 24.8c-11.7-11.7-27.8-18.1-47-18.1-20.3 0-35.2 6.4-47 12.9 20.3 11.7 64.1 36.3 110 70.5 1.1-4.3 1.1-9.6 1.1-13.9 1.1-21.5-5.3-39.6-17.1-51.4z",
  fill: "url(#swa_svg__paint2_linear_0_4)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.8 317.3c-1.8.4-4 .6-6.2.6-6.4 0-7.8-2.2-7.8-6.4v-24.1h-12V313c0 11.4 6.4 16.5 19.1 16.5 6.2 0 12-1.2 18.9-2.8v-39.2h-12.2l.2 29.8zm38.8 1.3c-4.4 0-4.9-2-4.9-5.4v-15.6h10v-10.2h-10v-12h-12v12h-6v10h6v16.3c0 7.2 1.4 15.6 13.4 15.6 3.6 0 6.6-.8 10-1.8l-1.2-10c-1.9.6-3.5 1.1-5.3 1.1zM29.9 296.1c-2.2-.8-4.8-1.6-7.4-2.4-6.9-2-9.1-2.9-9.1-6.2 0-3.6 2.6-5.4 8.9-5.4 5.2 0 9.8 1.4 14.3 2.9l2.6-11.6c-5.4-2-10.4-3.8-16.5-3.8-14.3 0-22.3 8.2-22.3 18 0 7.4 3.2 12.2 10.4 15.1 2 .8 4.6 1.6 7.2 2.4 7.8 2.4 10.2 3.6 10.2 6.6 0 3.6-2.9 5.6-9.1 5.6-5.6 0-10.7-1.6-16.2-4l-2.9 12c6 2.4 11.8 4 18.9 4 14.7 0 22.3-8.2 22.3-18.1 0-8-4.5-12.6-11.3-15.1zm157-10.7c-4 0-7.8.9-10.4 1.8v-19.8h-12v61.8h12v-30.9c2.2-.8 4.6-1.6 7.6-1.6 4.6 0 6.4 1.8 6.4 6.2v26.3h12v-27.6c-.1-10.9-5-16.2-15.6-16.2zm-121.2-.2c-12.2 0-21.9 8.6-21.9 21.9 0 13.4 9.8 22.3 21.9 22.3 12.2 0 21.9-8.7 21.9-22.3 0-13.6-9.7-21.9-21.9-21.9zm0 32.3c-5.2 0-9.4-3.8-9.4-10.5s4-10.4 9.4-10.4 9.4 3.6 9.4 10.4c0 6.9-4.1 10.5-9.4 10.5zm268.5-13.7c-1.8-.6-3.6-1.2-5.8-1.8-4.2-1.2-5.8-1.8-5.8-3.6s1.6-2.9 5.4-2.9c4 0 7.6.8 11.6 2l2-10.4c-4.4-.9-8.5-1.8-13.4-1.8-11.4 0-17.6 5.8-17.6 13.8 0 5.6 2.8 9.1 8.4 11.6 1.6.6 3.4 1.4 5.6 2 4.4 1.2 6.6 1.8 6.6 3.8 0 2-2.6 2.8-6.2 2.8-4.4 0-8.4-.8-12.5-2.4l-1.8 10.4c5.2 1.4 10 2.4 15.4 2.4 12 0 17.3-6.2 17.3-14-.3-5.5-2.4-9.5-9.2-11.9zm-44.8-18.6c-12.5 0-21.6 8.7-21.6 22.7 0 12.9 7.8 21.6 21.8 21.6 6.2 0 11.1-1.8 16.3-4l-1.8-10c-4 1.8-8 3.2-12.7 3.2-7.2 0-10.2-2.9-10.5-7.4h26.9s.4-4.8.4-5.8c-.1-11.2-6.3-20.3-18.8-20.3zm-8.4 18.2c.8-3.6 2.6-8.2 7.8-8.2 5.2 0 6.7 5.2 6.7 8.2H281zm85.9 15.2c-4.4 0-4.9-2-4.9-5.4v-15.6h10v-10.2h-10v-12h-12v12h-6.2v10.2h6.2v16.3c0 7.2 1.8 15.6 13.8 15.6 3.6 0 6.6-.8 10-1.8l-1.4-10c-2.2.4-3.8.9-5.5.9zm7.9-48.7c-2.9 0-5.2 2.4-5.4 5.4-.2 3 2.4 5.4 5.2 5.4 2.9 0 5.4-2.4 5.4-5.4 0-3-2.2-5.4-5.2-5.4zm0 9.8c-2.4 0-4.2-1.8-4.2-4.4 0-2.6 1.8-4.4 4.4-4.4 2.4 0 4.4 1.8 4.2 4.4-.2 2.6-2 4.4-4.4 4.4zm.6-4.2c1-.2 1.6-.6 1.6-1.6s-.8-1.8-2-1.8h-2v6.2h1.2v-2.6c.4 0 .6.2.8.6l1.4 2h1.4l-1.2-2c-.8-.4-1-.6-1.2-.8zm-.8-.6h-.6v-1.8h.8c.8 0 1 .4 1 .8 0 .8-.5 1-1.2 1zm-117.9 12.5l-7.6 22.9-7.6-22.9h-10.4l-7.8 22.9-7.6-22.9h-12.9l14.9 41.8h10.9l7.6-22.7 7.6 22.7h10.9l14.9-41.8h-12.9z",
  fill: "#304CB2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "swa_svg__paint0_linear_0_4",
  x1: 71.917,
  y1: 147.117,
  x2: 237.005,
  y2: 147.117,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3656CC"
}), React.createElement("stop", {
  offset: 0.35,
  stopColor: "#304CB2"
}), React.createElement("stop", {
  offset: 0.72,
  stopColor: "#283B80"
})), React.createElement("linearGradient", {
  id: "swa_svg__paint1_linear_0_4",
  x1: 95.43,
  y1: 15.868,
  x2: 282.123,
  y2: 146.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.3,
  stopColor: "#E61C23"
}), React.createElement("stop", {
  offset: 0.8,
  stopColor: "#C3161C"
})), React.createElement("linearGradient", {
  id: "swa_svg__paint2_linear_0_4",
  x1: 210.7,
  y1: -0.517,
  x2: 317.331,
  y2: 74.146,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDBC11"
}), React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FCB415"
}), React.createElement("stop", {
  offset: 0.8,
  stopColor: "#F89E1C"
})));

var Swa = function Swa(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 380 330",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default Swa;